import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GrupoIconos, ICONOS_DISPONIBLES } from '../iconos-disponibles';

export interface DialogSelectorIconoData {
  /** Icono actualmente elegido, para dejarlo marcado al abrir */
  iconoActual?: string
  titulo?: string
}

@Component({
  selector: 'app-dialog-selector-icono',
  templateUrl: './dialog-selector-icono.component.html',
  styleUrls: ['./dialog-selector-icono.component.css']
})
export class DialogSelectorIconoComponent {

  titulo = 'Elegir icono'
  seleccionado?: string
  busqueda = ''

  /** Lista completa; grupos es lo que se dibuja y cambia con el buscador */
  private readonly todos: GrupoIconos[] = ICONOS_DISPONIBLES
  grupos: GrupoIconos[] = ICONOS_DISPONIBLES

  constructor(
    private dialogRef: MatDialogRef<DialogSelectorIconoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSelectorIconoData
  ) {
    this.seleccionado = data?.iconoActual

    if (data?.titulo)
      this.titulo = data.titulo
  }

  filtrar() {
    const texto = (this.busqueda || '').trim().toLowerCase()

    if (!texto) {
      this.grupos = this.todos
      return
    }

    // Se filtran los iconos y se descartan los grupos que quedan vacíos, para no
    // dejar títulos de categoría colgando sin nada debajo.
    this.grupos = this.todos
      .map(m => ({ grupo: m.grupo, iconos: m.iconos.filter(f => f.indexOf(texto) >= 0) }))
      .filter(f => f.iconos.length > 0)
  }

  limpiarBusqueda() {
    this.busqueda = ''
    this.filtrar()
  }

  elegir(icono: string) {
    this.seleccionado = icono
  }

  /** Doble clic elige y cierra: el camino rápido para quien ya sabe cuál quiere */
  elegirYConfirmar(icono: string) {
    this.seleccionado = icono
    this.confirmar()
  }

  confirmar() {
    this.dialogRef.close({ icono: this.seleccionado })
  }

  quitar() {
    // null y no undefined: hay que poder distinguir "no elegí nada" de
    // "quiero dejarlo sin icono".
    this.dialogRef.close({ icono: null })
  }

  cancelar() {
    this.dialogRef.close()
  }

  get hayResultados(): boolean {
    return this.grupos.length > 0
  }
}
